import { hasAllPermissions } from 'src/utils/permissions';
import permissions from 'src/permissions';
import { defineMessages, IntlShape } from 'react-intl';

export const isSysAdmin = () =>
  hasAllPermissions(
    permissions.VIEW_DEVICES_ADD_BUTTON,
    permissions.VIEW_DEVICES_TENANT_ACTIONS,
    permissions.VIEW_DEVICES_TENANT_COLUMN,
    permissions.VIEW_DEVICES_EDIT_DEVICE_ACTION,
    permissions.VIEW_DEVICES_DELETE_DEVICE_ACTION,
  );
export const RssiDescription = defineMessages({
  excellent: {
    id: 'DeviceInfoModal.DeviceInfoModal.rssi.Excellent',
    defaultMessage: 'Excellent',
  },
  good: {
    id: 'DeviceInfoModal.DeviceInfoModal.rssi.Good',
    defaultMessage: 'Good',
  },
  fair: {
    id: 'DeviceInfoModal.DeviceInfoModal.rssi.Fair',
    defaultMessage: 'Fair',
  },
  poor: {
    id: 'DeviceInfoModal.DeviceInfoModal.rssi.Poor',
    defaultMessage: 'Poor',
  },
});
export const getDeviceRssi = (rssi: number, intl: IntlShape) => {
  switch (true) {
    case rssi >= -60 && rssi <= 0:
      return intl.formatMessage(RssiDescription.excellent);
    case rssi >= -70 && rssi <= -61:
      return intl.formatMessage(RssiDescription.good);
    case rssi >= -80 && rssi <= -70:
      return intl.formatMessage(RssiDescription.fair);
    case rssi <= -81:
      return intl.formatMessage(RssiDescription.poor);
    default:
      return '-';
  }
};
